import URLSearchParams from './classes/URLSearchParams.js';
import FormData from './classes/FormData.js';
var isStandardBrowserEnv = function () {
    var product;
    if (typeof navigator !== 'undefined' && ((product = navigator.product) === 'ReactNative' || product === 'NativeScript' || product === 'NS')) {
        return false;
    }
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}();
var isStandardBrowserWebWorkerEnv = function () {
    return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
}();
export default {
    isBrowser: true,
    classes: {
        URLSearchParams: URLSearchParams,
        FormData: FormData,
        Blob: Blob
    },
    isStandardBrowserEnv: isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv: isStandardBrowserWebWorkerEnv,
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};